'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _withToggle = require('constructicon/with-toggle');

var _withToggle2 = _interopRequireDefault(_withToggle);

var _files = require('constructicon/lib/files');

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _leaderboardItem = require('constructicon/leaderboard-item');

var _leaderboardItem2 = _interopRequireDefault(_leaderboardItem);

var _icon = require('constructicon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _modal = require('constructicon/modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputModal = function InputModal(_ref) {
  var buttonProps = _ref.buttonProps,
      cardProps = _ref.cardProps,
      children = _ref.children,
      data = _ref.data,
      onToggle = _ref.onToggle,
      onToggleOff = _ref.onToggleOff,
      toggled = _ref.toggled,
      type = _ref.type,
      width = _ref.width;

  var cardData = function cardData() {
    switch (type) {
      case 'video':
        return {
          image: data.thumbnail_url,
          subtitle: [data.author_name, data.provider_name].join(' - '),
          title: data.title
        };
      default:
        return {
          image: data.preview,
          subtitle: (0, _files.formatFileSize)(data.image.size),
          title: data.image.name
        };
    }
  };

  var label = 'Add ' + (type === 'image' ? 'an' : 'a') + ' ' + type;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    data ? _react2.default.createElement(
      _button2.default,
      _extends({}, buttonProps, { block: true, spacing: 0.25, onClick: onToggle }),
      _react2.default.createElement(_leaderboardItem2.default, _extends({}, cardProps, cardData()))
    ) : _react2.default.createElement(
      _button2.default,
      _extends({}, buttonProps, {
        'aria-label': label,
        block: true,
        spacing: 0.5,
        onClick: onToggle,
        background: 'transparent',
        borderColor: 'primary',
        borderWidth: 2,
        foreground: 'primary'
      }),
      _react2.default.createElement(_icon2.default, { name: type }),
      _react2.default.createElement(
        'span',
        null,
        label
      )
    ),
    _react2.default.createElement(
      _modal2.default,
      {
        width: width,
        isOpen: toggled,
        contentLabel: 'Add ' + type + ' to post',
        onRequestClose: onToggleOff
      },
      children,
      _react2.default.createElement(
        _button2.default,
        _extends({}, buttonProps, { block: true, onClick: onToggleOff }),
        data ? 'Add ' + type + ' to post' : 'Cancel'
      )
    )
  );
};

InputModal.defaultProps = {
  cardProps: {
    avatarRadius: 'medium',
    linkTag: 'div',
    tag: 'div',
    margin: 0,
    spacing: 0
  },
  width: 16
};

exports.default = (0, _withToggle2.default)(InputModal);